
























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { UserViewModel, UserService } from '../../api/user';
import global from '../../utils/global';
import { PagedList } from '../../api/PagedList';
import UserImport from '../User/Import.vue';
import ResetPassword from '../User/ResetPassword.vue';
import { Message, MessageBox } from 'element-ui';
@Component({
  components: {
    UserImport,
    ResetPassword,
  },
})
export default class UserList extends Vue {
  private service: UserService = new UserService();
  private condition: UserViewModel = this.service.NewModel;
  private data: PagedList<UserViewModel> = new PagedList<UserViewModel>();
  private currentRow!: UserViewModel;
  private selectUserId: string = '';
  private userType: any = global.getUserType();
  private pageIndex: number = 1;
  private showImport: boolean = false;
  private showResetPassword: boolean = false;
  private beforeRouteEnter(to: any, from: any, next: any) {
    if (global.getUserType() < 2) {
      next({name: 'home'});
    } else {
      next();
    }
  }
  private mounted() {
    this.condition.status = -1;
    this.condition.userType = -1;
    this.loadData(1);
  }
  private page_OnChange(page: number) {
    this.loadData(page);
  }
  private loadData(page: number) {
    this.service.Search(this.condition, page).then((response: any) => {
      this.pageIndex = page;
      this.data = response;
    });
  }
  private btnSearch_OnClick() {
    this.loadData(1);
  }
  private Import_OnSaved() {
    this.loadData(1);
    Message.success('导入成功！');
    this.showImport = false;
  }
  private row_OnChange(currentRow: any) {
    this.currentRow = currentRow;
  }
  private btnDelete_OnClick() {
    if (this.currentRow) {
      MessageBox.confirm(
        '是否删除？',
        '警告',
        {
          confirmButtonText: '删除',
          cancelButtonText: '返回',
          type: 'warning',
        },
      ).then(() => {
        this.service.Delete(this.currentRow.id!).then((val: any) => {
          Message.success('删除成功！');
          this.loadData(1);
        });
      });
    } else {
      MessageBox.alert(
        '请选择要操作的行！',
        '操作失败',
       {
          type: 'warning',
        },
      );
    }
  }
  private ResetPassword_OnSaved() {
    Message.success('重置成功！');
    this.showResetPassword = false;
  }
  private btnResetPassword_OnClick() {
    if (this.currentRow) {
      this.selectUserId = this.currentRow.id!;
      this.showResetPassword = true;
    } else {
      MessageBox.alert(
        '请选择要操作的行！',
        '操作失败',
       {
          type: 'warning',
        },
      );
    }
  }
}
